import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-app-topbar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="app-topbar">
      <div class="app-topbar__start">
        <ng-content select="[libAppTopbarStart]"></ng-content>
        @if (hasTitle) {
          <div class="app-topbar__title">{{ title }}</div>
        }
      </div>

      <div class="app-topbar__end">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .app-topbar {
      min-height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
    }

    .app-topbar__start {
      min-width: 0;
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1 1 auto;
    }

    .app-topbar__title {
      font-size: 18px;
      font-weight: 600;
      color: var(--tenant-secondary, #111827);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .app-topbar__end {
      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
      flex: 1 1 auto;
    }

    @media (max-width: 1040px) {
      .app-topbar {
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
        padding: 8px 0;
      }

      .app-topbar__start,
      .app-topbar__end {
        width: 100%;
      }

      .app-topbar__end {
        justify-content: flex-start;
        flex-wrap: wrap;
      }
    }

    @media (max-width: 640px) {
      .app-topbar {
        gap: 10px;
      }

      .app-topbar__title {
        max-width: 100%;
        font-size: 16px;
      }
    }
  `],
})
export class AppTopbarComponent {
  @Input() public title = '';

  protected get hasTitle(): boolean {
    return this.title.trim().length > 0;
  }
}
